import { media, styled } from '@nx-kit/styling';

export const WrapperRBSalutations = styled.div`
  ${media('sm')} {
    display: flex;
  }
  > * {
    display: flex;
    padding-top: 14px;

    &:first-child {
      padding-top: 0;
    }

    ${media('sm')} {
      padding-top: 0;
    }
  }
`;

export const WrapperRBArrivalPlace = styled.div`
  ${media('sm')} {
    display: flex;
  }
  > * {
    display: flex;
    padding-top: 14px;

    &:first-child {
      padding-top: 0;
    }

    ${media('sm')} {
      padding-top: 0;
    }
  }
`;

export const WrapperRBNumberOfEntries = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > * {
    width: 100%;
    ${media('md')} {
      width: 45%;
    }

    &:first-child {
      align-self: flex-end;
    }
  }
`;

export const WrapperRBPayment = styled.div`
  > * {
    display: flex;
    padding-top: 14px;

    &:first-child {
      padding-top: 0;
    }
  }
`;

export const SortGroupWithSpaceStyled = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

export const DateGroupStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 20px;
  > * {
    width: 100%;
  }
  .react-datepicker__header {
    position: relative;
    background: #fff;
    border: none;
    padding: 10px 0 6px 0;
    text-align: center;
    box-shadow: none;
    border-bottom: 1px solid #eee; /* optional subtle line */
  }
  /* Centered month name */
  .react-datepicker__current-month {
    position: relative;
    font-weight: 600;
    font-size: 1rem;
    color: #000;
    text-align: center;
    margin: 0;
    z-index: 2; /* keeps above arrows */
  }
  /* Arrows — perfect position and spacing */
  .react-datepicker__navigation {
    position: absolute;
    top: 10px;
    transform: none;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 3;
    padding: 6px;
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* Left and right offset to prevent overlap */
  .react-datepicker__navigation--previous {
    left: 6px;
  }

  .react-datepicker__navigation--next {
    right: 6px;
  }
  /* Optional: make arrow icons thinner and cleaner */
  .react-datepicker__navigation-icon::before {
    border-color: #000; /* black icon */
    border-width: 2px 2px 0 0; /* thin clean line */
    height: 8px;
    width: 8px;
  }

  ${media('md')} {
    flex-wrap: nowrap;
    gap: 24px;
    align-items: flex-start;
    > * {
      flex: 1;
      min-width: 260px;
    }
    /* Make datepicker slightly wider */
    > *:first-child {
      flex: 1.3;
    }
    /* Keep time dropdown proportional */
    > *:last-child {
      flex: 1;
    }
  }
  /* Inputs and buttons sizing */
  input,
  .select__control,
  div div button {
    height: 57px;
    width: 100%;
    font-size: 16px;
  }
  /* Control styling */
  .select__control {
    padding: 6px 12px;
  }

  .time-dropdown .select__menu {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr); /* left = hours, right = minutes */
    gap: 12px;
    padding: 14px;
    max-height: 280px;
    overflow-y: auto;
    background: #fff;
    border-radius: 10px;
    position: relative;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
  /* Divider line */
  .time-dropdown .select__menu::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 10px;
    bottom: 10px;
    width: 1px;
    background: #e5e5e5;
  }
  /* Time options styling */
  .time-dropdown .select__option {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid transparent;
    transition: all 0.2s ease;
    padding: 8px;
    text-align: center;
    z-index: 1;
  }
  .time-dropdown .select__option:hover {
    background: #f5f5f5;
    border-color: #ddd;
  }
  .time-dropdown .select__option--is-selected {
    background: #000;
    color: #fff;
  }
  /* Responsive for small screens */
  ${media('sm')} {
    .time-dropdown .select__menu {
      grid-template-columns: 1fr 1fr;
      gap: 10px;
    }
    .time-dropdown .select__menu::before {
      left: 50%;
    }
  }
`;
